import {Button} from "@/components/ui/button.tsx";
import {Link} from "react-router";

export default function LoginErrorView() {
    return <main className="grid min-h-full place-content-center gap-4 p-6 text-center">
        <title>Anmeldung fehlgeschlagen | DireDawn</title>
        <h1 className="text-xl font-medium">Anmeldung fehlgeschlagen</h1>
        <p className="text-muted-foreground">Die Anmeldung wurde abgebrochen oder vom Anbieter abgelehnt.</p>
        <Button asChild><Link to="/login">Zur Anmeldung</Link></Button>
    </main>;
}
